import { Asset } from 'src/modules/common/types/Asset';
import { Future } from 'src/modules/common/types/Future';
import { RootState } from 'src/types/RootState';

export function getAssetState(state: RootState, id: string): Future<Asset> | null {
  return state.asset.get(id) ?? null;
}
